module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#magazines",
      toString: function () {
        return this.url;
      }
    }